import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import ReactTable from 'react-table';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, UncontrolledTooltip } from "reactstrap";
import axios from 'axios';
import update from 'immutability-helper';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import './Advertising.scss';
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';


class AdvertisingList extends Component {

    constructor(props) {
        super(props);

        this.loadListAdvertising = this.loadListAdvertising.bind(this);
        this.handleError = this.handleError.bind(this);
        this.refreshTableAdvertising = this.refreshTableAdvertising.bind(this);
        this.confirmaStatusPublicacao = this.confirmaStatusPublicacao.bind(this);
        this.selecionaAnuncio = this.selecionaAnuncio.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.mudaStatusAnuncio = this.mudaStatusAnuncio.bind(this);




        this.state = {

            // botao: '/publicidades/detalhes',
            // idPublicidade: '',
            listaPublicidades: [],
            paginaPublicidades: 1,
            qdtItens: 10,
            pagina: 0,
            nomeMidia: 'Publicidades',
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "toggle",
            isLoadingStatusAnuncio: false,
            openModal: false,
            hasError: false,
            errorMessage: '',
            isLoadingAdvertising: true,
            idAnuncio: '',
            dtInicio: '',
            dtFim: '',


        }
        this.Configurations = new Configurations();

        this.columns = [
            {
                Header: 'ID',
                accessor: '_id',
                className: 'text-center pointer',
                width: 100
            },
            {
                Header: 'Imagem',
                accessor: 'imagem',
                className: 'pointer',
                width: 100,
                Cell: row =>
                    <ImagemFukyo className={`img img-imagem-publicidade`} src={row.original.imagem} alt={`imagem da publicidade`}/>

            },
            {
                Header: 'Veículo',
                accessor: 'veiculo',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (
                    !!row.value && <span className={`badge badge-${this.vehicleBadgeType(row.value)} mx-1`}>{row.value}</span>
                )

            },
            {
                Header: 'Link',
                accessor: 'link',
                className: 'pointer',
                width: 130

            },
            {
                Header: 'Data início ',
                accessor: 'dtInicio',
                className: 'text-center pointer',
                width: 130,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YYYY")}</span> : <span>erro</span>)

            },
            {
                Header: 'Data fim',
                accessor: 'dtFim',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YYYY")}</span> : <span>erro</span>)

            },
            {
                Header: 'Data criação ',
                accessor: 'dtCriacao',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YYYY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Status',
                accessor: 'ativo',
                className: 'text-center pointer',
                width: 130,
                Cell: row => {
                    const _habilitado = row.value,
                        _texto = _habilitado ? "Habilitado" : "Não habilitado",
                        _cor = _habilitado ? "success" : "secondary";
                    return (
                        <span className={`badge badge-${_cor}`}>{_texto}</span>
                    )
                }
            },
            {
                Header: '',
                accessor: 'ativo',
                className: 'text-center pointer',
                // width: 80,
                Cell: row => {
                    const _publicado = row.original.ativo,
                        _functionBtn = _publicado ? "desabilitar" : "habilitar",
                        _classIcon = _publicado ? `far fa-eye-slash` : `far fa-eye`,
                        _textToolTip = _publicado ? 'desabilitar anúncio' : 'habilitar anúncio';

                    return (
                        <div className="row no-gutters">
                            <div className="col-12 icones" id={`Tooltip-${row.original._id}`}>
                                {row.original.loading ? (
                                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                ) : (
                                        <button onClick={() => this.confirmaStatusPublicacao(row.original, _functionBtn)}>
                                            <i className={_classIcon}></i>
                                        </button>
                                    )}
                                <UncontrolledTooltip placement="top" target={`Tooltip-${row.original._id}`}>
                                    {_textToolTip}
                                </UncontrolledTooltip>
                            </div>
                        </div>
                    )
                },
            },
        ]
    }


    confirmaStatusPublicacao(anuncio, metodo) {
        this.toggleStatusPublicacao();
        this.setState({
            idAnuncioStatusPublicacao: anuncio._id,
            metodoStatusPublicacao: metodo,

        })
    }

    vehicleBadgeType(status) {
        switch (status) {
            case "BS":
                return "primary";
            case "TC":
                return "danger";
            case "RD":
                return "warning";
            default:
                return "info";
        }
    }
    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.msg })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    loadListAdvertising(o) {
        this.setState({ isLoadingAdvertising: true })
        const _params = [];
        if (o === undefined) {
            _params.push(`pagina=${this.state.pagina + 1}`);
            _params.push(`qtdItens=${this.state.qtdItens}`);
        }
        else if (!o.pageSize) {
            o.pageSize = this.state.qtdItens;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = this.state.pagina;
            _params.push(`pagina=${o.page + 1}`);
        } else {
            _params.push(`pagina=${o.page + 1}`);
            _params.push(`qtdItens=${o.pageSize}`);
            this.setState({
                pagina: o.page,
                qtdItens: o.pageSize
            })
        }
        this.setState({
            queryParametros: _params,
        }, () => {
            const _anuncios = axios.get(this.Configurations.apiBasePath + `/publicidades?${this.state.queryParametros.join('&')}`);
            _anuncios.then(response => {
                this.setState({
                    listaPublicidades: response.data.publicidades,
                    paginasPublicidades: response.data.paginacao.totalPaginas,
                });
            }).catch(this.handleError).finally(() => this.setState({
                isLoadingAdvertising: false
            }));

        })

    }

    selecionaAnuncio(idAnuncio) {
        this.props.history.push(`/publicidades/${idAnuncio}`)

    }
    refreshTableAdvertising(o) {
        this.loadListAdvertising(o);
    }

    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    mudaStatusAnuncio() {
        this.setState({ isLoadingStatusAnuncio: true })
        const _index = this.state.listaPublicidades.findIndex(item => item._id === this.state.idAnuncioStatusPublicacao);

        this.setState({ listaPublicidades: update(this.state.listaPublicidades, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/publicidades/${this.state.idAnuncioStatusPublicacao}/toggle`).then(response => { }).catch(this.handleError).finally(() => {
            this.loadListAdvertising();
            this.toggleStatusPublicacao();
            this.setState({
                isLoadingStatusAnuncio: false,
                isLoadingAdvertising: false,
                listaPublicidades: update(this.state.listaPublicidades, { [_index]: { loading: { $set: false } } })
            })
        });
    }

    render() {
        return (
            <div className="row advertising-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block px-3">{this.state.nomeMidia} - Lista de Anúncios</h2>
                            <h4 className="d-lg-none">{this.state.nomeMidia}</h4>
                            <h2 className="d-lg-none">Lista de Anúncios</h2>
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button className="btn btn-outline-info mx-2 my-2" type="button" name="novoAnuncio" onClick={() => this.props.history.push(`/publicidades/novo-anuncio`)}>
                                        Criar publicidade
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`col-12`}>
                        <div className="row no-gutters">
                            <div className={`col-12`}>
                                <div className="row no-gutters">
                                    <div className={`col-12 text-center text-lg-left`}>
                                        <p className="py-2 m-0">Clique no anúncio para obter informações</p>
                                        <div className="card mt-2">
                                            <div className="card-body p-0">
                                                <ReactTable
                                                    columns={this.columns}
                                                    data={this.state.listaPublicidades}
                                                    onFetchData={this.refreshTableAdvertising}
                                                    defaultPageSize={10}
                                                    pages={this.state.paginasPublicidades}
                                                    page={this.state.pagina}
                                                    manual
                                                    noDataText='Nenhum anúncio encontrado.'
                                                    pageSize={this.state.qtdItens}
                                                    loading={this.state.isLoadingAdvertising}
                                                    className="-striped -highlight"
                                                    headerClassName="ebs-table-header"
                                                    pageText='Página'
                                                    ofText='de'
                                                    rowsText='linhas'
                                                    previousText='Anterior'
                                                    nextText='Próximo'
                                                    getTdProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            onClick: (e, handleOriginal) => {
                                                                if (rowInfo) {
                                                                    if (column.Header === '') handleOriginal();
                                                                    else this.selecionaAnuncio(rowInfo.original._id)
                                                                }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                        <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status do Anúncio</ModalHeader>
                        <ModalBody>
                            {this.state.metodoStatusPublicacao === 'habilitar' ? (
                                <p className="m-0">{`Tem certeza que deseja confirmar a publicação desse anúncio?`}</p>
                            ) : (
                                    <p className="m-0">{`Tem certeza que deseja desabilitar a publicação desse anúncio?`}</p>
                                )}

                        </ModalBody>
                        <ModalFooter>
                            {this.state.isLoadingStatusAnuncio ? (
                                <div className="spinner-border text-primary" role="status" />
                            ) : (
                                    <Button disabled={this.state.isLoadingStatusAnuncio} color={`${this.state.metodoStatusPublicacao === 'habilitar' ? `success` : `danger`}`} onClick={this.mudaStatusAnuncio}>confirmar</Button>
                                )}
                            {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                        </ModalFooter>
                    </Modal>
                    <ErrorModal
                        isOpen={this.state.hasError}
                        message={this.state.errorMessage}
                        closeErrorModal={this.closeErrorModal}
                    />
                </div>
            </div>
        )

    }
}

export default AdvertisingList;